import { TabStrip, TabStripSelectEventArguments } from "@progress/kendo-react-layout";
import React, { useEffect, useState } from "react";
import { makeSideBarActive } from "../../utils/ellowutils";
import SideMenu from "../sideMenu";
import DashboardHeader from "../topbar";
import * as CONSTANTS from "../../utils/CONSTANTS";
import Tab from "../../compopnents/tab";
import Styles from "./styles.module.scss";
import AllResources from "./allresources";
import { getAllResources} from "./services";
import { viewedpageMixpanel } from "../../utils/mixpanel";

const BreadcrumsValues = ["Contract Resources"];

function ContractResources() {
  const [selected, setSelected] = useState<number>(0);
  const [upcomingJoineeData, setUpcomingJoineeData] = useState<any>()
  const [inContractResources, setIncontractResources] = useState<any>()
  const [customerId, setCustomerId] = useState<any>(localStorage.getItem('customerId'))
  const handleSelect = (e: TabStripSelectEventArguments) => {
    setSelected(e.selected);
  };

  useEffect(() => {
    
    getContractResources(0, 1, 25, '')
    getContractResources(1, 1, 25,'')
    setCustomerId(localStorage.getItem('customerId'));
    viewedpageMixpanel();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerId])

  
  const getContractResources = (tab: number, pageNumber: number, pageSize: number, search: string) => {

    let tabName: string | undefined = findTabName(tab)
    let id = customerId
    let body = {
      filters: { }
    }
    getAllResources(id, tabName, pageNumber, pageSize, search, body).then((response) => { 
      if (response && response.status === 1) {
        switch (tab) {
          case 0:
            setIncontractResources(response.data)
            break
          case 1:
            setUpcomingJoineeData(response.data)
            break
        }
      }
    })
  }

  
  const findTabName = (value: number) => {
    switch (value) {
      case 0:
        return 'Incontract';
      case 1:
        return 'upcoming';
      default:
        break;
    }
  }
  
  const menu = makeSideBarActive(CONSTANTS.sideMenu, 2);

  const Resources = (
    <>
      All Resources <i>{inContractResources && inContractResources.length}</i>
    </>
  );
  const upcomingjoinee = (
    <>
      Upcoming Joinee <i>{upcomingJoineeData && upcomingJoineeData.length}</i>
    </>
  );

  const pageChange = (pageSize: number, pageNumber: number) => {
    let page = pageNumber !== 0 ? Math.floor(pageNumber / pageSize) + 1 : 1;     
    getContractResources(selected, page, pageSize, '')    
  }
  
  const searchChange = (e: any) => {
    getContractResources( 0, 1, 25, e)
    getContractResources( 1, 1, 25, e)
  }

  return (
    <section className="dashboardWrapper">
      <SideMenu menu={menu} />
      <div className="dashboardContent">
        <DashboardHeader
          title={BreadcrumsValues}
          searchChange={searchChange}
          type='resources'
        />
        <section className={Styles.positionWrapper}>
          {/* <div className={Styles.activePositions}>
            <img src={crownIcon} />
            Active positions<span>{78}</span>
          </div> */}
          <TabStrip selected={selected} onSelect={handleSelect}>
            <Tab title={Resources}>
              <AllResources data={inContractResources} pageSize={pageChange} />
            </Tab>
            <Tab title={upcomingjoinee}>
              <AllResources data={upcomingJoineeData} pageSize={pageChange}/>
            </Tab>
          </TabStrip>
        </section>
      </div>
    </section>
  );
}

export default ContractResources;
